import {
  BlotterRow,
  OrderColumnInfo,
  OrdersTableMetadata,
} from "@enfusion-ui/core";
import { noop } from "lodash";
import * as React from "react";
import { SocketData } from "types/socket";

export type OemsTransactions = {
  add?: BlotterRow[];
  update?: BlotterRow[];
  remove?: BlotterRow[];
  action: string;
  callback?: (rows: BlotterRow[], allRows?: BlotterRow[]) => void;
};

export type OEMSContextState = {
  orderColumns: OrderColumnInfo[] | undefined;
  metadata: OrdersTableMetadata | undefined;
  isInitialized: boolean;
  hasError: boolean;
  errorMessage: string | null;
  readyState?: number;
  initializationStep: number;
  initializationMessage: string;
  initializeOEMS: (secureToken?: string) => void;
  closeSocket: () => void;
};

export type OEMSLocalState = {
  restartSocket: (secureToken?: string) => void;
  messages: SocketData[];
};

export const initialOEMSContextState: OEMSContextState & OEMSLocalState = {
  orderColumns: undefined,
  metadata: undefined,
  isInitialized: false,
  hasError: false,
  errorMessage: null,
  readyState: undefined,
  initializationStep: 0,
  initializationMessage: "",
  messages: [],
  restartSocket: noop,
  initializeOEMS: noop,
  closeSocket: noop,
};

//oems context
export const OEMSContext = React.createContext<
  OEMSContextState & OEMSLocalState
>(initialOEMSContextState);

//oems blotter transaction context
export const OEMSBlotterRowsTransactionContext =
  React.createContext<OemsTransactions>({
    action: "",
  });

export const OEMS_INITIALIZATION_STEPS = 12;

export function useOEMS() {
  const context = React.useContext<OEMSContextState & OEMSLocalState>(
    OEMSContext
  );
  if (context === undefined) {
    throw new Error("useOEMS must be used within a OEMSProvider");
  }
  return context;
}

export function useOEMSBlotterRowsTransaction() {
  const context = React.useContext(OEMSBlotterRowsTransactionContext);
  if (context === undefined) {
    throw new Error(
      "useOEMSBlotterRowsTransaction must be used within a OEMSBlotterRowsTransactionProvider"
    );
  }
  return context;
}
